import { Error404Fragment, withErrorLayout } from ".";
import { VolunteerSearchLink } from "..";

export const OrganisationDetails404Fragment = (): JSX.Element => {
  return (
    <Error404Fragment title="This organisation isn&#8217;t here.">
      <p className="mb-4">Sorry this organisation is no longer available.</p>
      <p>
        You can{" "}
        <VolunteerSearchLink
          to="/volunteering-organisations"
          searchQuery={{}}
          searchType="org"
        >
          search for other organisations
        </VolunteerSearchLink>
        .
      </p>
    </Error404Fragment>
  );
};

export const OrganisationDetails404 = withErrorLayout<Record<string, never>>(
  OrganisationDetails404Fragment,
  404
);
